// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Theme Presets
 * Complete token sets applied via .theme-* class on <body>.
 * Default theme ("Tonal: OHIF Blue") = no class (uses :root values from tailwind.css).
 * Outside @layer base so presets override :root via proximity on <body>.
 *
 * Tonal themes: full hue-shifted palettes (surfaces, borders, text all carry the theme hue).
 * Neutral themes: desaturated/achromatic surfaces with a colored primary accent.
 */

/* ─── Tonal: Orchid ──────────────────────────────────────────────────── */

.theme-orchid {
  --highlight: 292 75% 62%;
  --neutral: 270 18% 55%;
  --neutral-light: 275 35% 75%;
  --neutral-dark: 268 20% 24%;
  --background: 270 45% 6%;
  --foreground: 280 15% 96%;
  --card: 268 40% 10%;
  --card-foreground: 280 15% 96%;
  --popover: 264 48% 13%;
  --popover-foreground: 280 15% 96%;
  --primary: 270 85% 65%;
  --primary-foreground: 0 0% 98%;
  --secondary: 268 45% 32%;
  --secondary-foreground: 275 45% 88%;
  --muted: 268 40% 10%;
  --muted-foreground: 272 30% 60%;
  --accent: 268 50% 20%;
  --accent-foreground: 280 15% 96%;
  --destructive: 0 65% 40%;
  --destructive-foreground: 0 0% 98%;
  --border: 268 30% 18%;
  --input: 268 40% 25%;
  --ring: 270 80% 60%;
  --chart-1: 270 70% 58%;
  --chart-2: 160 55% 45%;
  --chart-3: 35 80% 55%;
  --chart-4: 200 65% 55%;
  --chart-5: 340 70% 55%;
}

/* ─── Tonal: Arctic ──────────────────────────────────────────────────── */

.theme-arctic {
  --highlight: 173 81% 52%;
  --neutral: 185 20% 55%;
  --neutral-light: 180 40% 78%;
  --neutral-dark: 190 18% 22%;
  --background: 0 0% 0%;
  --foreground: 180 10% 97%;
  --card: 203 39% 9%;
  --card-foreground: 180 10% 97%;
  --popover: 202 54% 11%;
  --popover-foreground: 180 10% 97%;
  --primary: 175 85% 42%;
  --primary-foreground: 185 50% 8%;
  --secondary: 180 45% 28%;
  --secondary-foreground: 175 50% 88%;
  --muted: 203 39% 9%;
  --muted-foreground: 185 30% 60%;
  --accent: 185 55% 18%;
  --accent-foreground: 180 10% 97%;
  --destructive: 0 65% 35%;
  --destructive-foreground: 0 0% 98%;
  --border: 190 25% 17%;
  --input: 223 40% 24%;
  --ring: 175 85% 42%;
  --chart-1: 175 75% 45%;
  --chart-2: 140 60% 42%;
  --chart-3: 35 80% 55%;
  --chart-4: 280 65% 58%;
  --chart-5: 330 75% 55%;
}

/* ─── Tonal: Verdant ─────────────────────────────────────────────────── */

.theme-verdant {
  --highlight: 152 79% 52%;
  --neutral: 150 15% 52%;
  --neutral-light: 145 30% 72%;
  --neutral-dark: 155 18% 24%;
  --background: 155 40% 5%;
  --foreground: 140 15% 95%;
  --card: 152 35% 9%;
  --card-foreground: 140 15% 95%;
  --popover: 167 65% 10%;
  --popover-foreground: 140 15% 95%;
  --primary: 152 75% 40%;
  --primary-foreground: 155 50% 8%;
  --secondary: 150 40% 26%;
  --secondary-foreground: 145 40% 85%;
  --muted: 152 35% 9%;
  --muted-foreground: 148 25% 55%;
  --accent: 150 45% 16%;
  --accent-foreground: 140 15% 95%;
  --destructive: 0 65% 38%;
  --destructive-foreground: 0 0% 98%;
  --border: 150 25% 16%;
  --input: 150 35% 22%;
  --ring: 152 75% 40%;
  --chart-1: 152 70% 42%;
  --chart-2: 200 60% 48%;
  --chart-3: 35 80% 55%;
  --chart-4: 280 60% 55%;
  --chart-5: 340 70% 52%;
}

/* ─── Neutral: Midnight ──────────────────────────────────────────────── */

.theme-midnight {
  --highlight: 188 90% 58%;
  --neutral: 213 22% 59%;
  --neutral-light: 214 69% 81%;
  --neutral-dark: 214 16% 21%;
  --background: 240 15% 3%;
  --foreground: 0 0% 99%;
  --card: 240 12% 8%;
  --card-foreground: 0 0% 99%;
  --popover: 225 45% 13%;
  --popover-foreground: 0 0% 99%;
  --primary: 210 100% 62%;
  --primary-foreground: 0 0% 99%;
  --secondary: 215 55% 32%;
  --secondary-foreground: 200 60% 88%;
  --muted: 240 12% 8%;
  --muted-foreground: 210 40% 70%;
  --accent: 220 65% 20%;
  --accent-foreground: 0 0% 99%;
  --destructive: 0 70% 35%;
  --destructive-foreground: 0 0% 99%;
  --border: 240 10% 18%;
  --input: 225 35% 24%;
  --ring: 210 100% 62%;
  --chart-1: 210 85% 55%;
  --chart-2: 165 70% 42%;
  --chart-3: 35 85% 52%;
  --chart-4: 275 70% 58%;
  --chart-5: 335 80% 52%;
}

/* ─── Neutral: Slate ─────────────────────────────────────────────────── */

.theme-slate {
  --highlight: 217 97% 52%;
  --neutral: 0 0% 55%;
  --neutral-light: 0 0% 75%;
  --neutral-dark: 0 0% 25%;
  --background: 0 0% 0%;
  --foreground: 0 0% 96%;
  --card: 0 0% 7%;
  --card-foreground: 0 0% 96%;
  --popover: 0 0% 9%;
  --popover-foreground: 0 0% 96%;
  --primary: 230 75% 55%;
  --primary-foreground: 0 0% 98%;
  --secondary: 0 0% 25%;
  --secondary-foreground: 0 0% 85%;
  --muted: 0 0% 7%;
  --muted-foreground: 0 0% 60%;
  --accent: 0 0% 18%;
  --accent-foreground: 0 0% 96%;
  --destructive: 0 65% 40%;
  --destructive-foreground: 0 0% 98%;
  --border: 0 0% 18%;
  --input: 0 0% 22%;
  --ring: 215 75% 55%;
  --chart-1: 215 70% 55%;
  --chart-2: 160 55% 45%;
  --chart-3: 35 75% 55%;
  --chart-4: 280 60% 58%;
  --chart-5: 340 70% 55%;
}

/* ─── Neutral: Deep ──────────────────────────────────────────────────── */

.theme-deep {
  --highlight: 184 53% 54%;
  --neutral: 215 15% 50%;
  --neutral-light: 210 20% 68%;
  --neutral-dark: 220 18% 22%;
  --background: 0 0% 0%;
  --foreground: 215 15% 82%;
  --card: 218 25% 5%;
  --card-foreground: 215 15% 82%;
  --popover: 215 30% 8%;
  --popover-foreground: 215 15% 82%;
  --primary: 200 43% 48%;
  --primary-foreground: 210 20% 92%;
  --secondary: 218 30% 18%;
  --secondary-foreground: 215 25% 75%;
  --muted: 214 28% 5%;
  --muted-foreground: 215 18% 48%;
  --accent: 216 32% 12%;
  --accent-foreground: 215 15% 82%;
  --destructive: 0 50% 35%;
  --destructive-foreground: 0 15% 90%;
  --border: 218 22% 10%;
  --input: 216 28% 15%;
  --ring: 215 45% 42%;
  --chart-1: 215 50% 45%;
  --chart-2: 175 40% 38%;
  --chart-3: 35 50% 45%;
  --chart-4: 280 40% 48%;
  --chart-5: 340 45% 45%;
}
`, "",{"version":3,"sources":["webpack://./../../ui-next/src/themes/themes.css"],"names":[],"mappings":"AAAA;;;;;;;EAOE;;AAEF,2EAA2E;;AAE3E;EACE,wBAAwB;EACxB,sBAAsB;EACtB,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;EACxB,yBAAyB;EACzB,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,iCAAiC;EACjC,sBAAsB;EACtB,8BAA8B;EAC9B,wBAAwB;EACxB,mCAAmC;EACnC,oBAAoB;EACpB,+BAA+B;EAC/B,qBAAqB;EACrB,gCAAgC;EAChC,wBAAwB;EACxB,kCAAkC;EAClC,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;EACtB,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA,2EAA2E;;AAE3E;EACE,wBAAwB;EACxB,sBAAsB;EACtB,4BAA4B;EAC5B,2BAA2B;EAC3B,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;EAC9B,sBAAsB;EACtB,iCAAiC;EACjC,sBAAsB;EACtB,gCAAgC;EAChC,wBAAwB;EACxB,mCAAmC;EACnC,mBAAmB;EACnB,+BAA+B;EAC/B,qBAAqB;EACrB,gCAAgC;EAChC,wBAAwB;EACxB,kCAAkC;EAClC,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;EACtB,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA,2EAA2E;;AAE3E;EACE,wBAAwB;EACxB,sBAAsB;EACtB,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;EACxB,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;EAC9B,sBAAsB;EACtB,iCAAiC;EACjC,sBAAsB;EACtB,gCAAgC;EAChC,wBAAwB;EACxB,mCAAmC;EACnC,mBAAmB;EACnB,+BAA+B;EAC/B,qBAAqB;EACrB,gCAAgC;EAChC,wBAAwB;EACxB,kCAAkC;EAClC,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;EACtB,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA,2EAA2E;;AAE3E;EACE,wBAAwB;EACxB,sBAAsB;EACtB,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;EACxB,sBAAsB;EACtB,kBAAkB;EAClB,2BAA2B;EAC3B,sBAAsB;EACtB,8BAA8B;EAC9B,uBAAuB;EACvB,8BAA8B;EAC9B,wBAAwB;EACxB,mCAAmC;EACnC,mBAAmB;EACnB,+BAA+B;EAC/B,qBAAqB;EACrB,6BAA6B;EAC7B,wBAAwB;EACxB,kCAAkC;EAClC,qBAAqB;EACrB,oBAAoB;EACpB,oBAAoB;EACpB,sBAAsB;EACtB,sBAAsB;EACtB,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA,2EAA2E;;AAE3E;EACE,wBAAwB;EACxB,mBAAmB;EACnB,yBAAyB;EACzB,wBAAwB;EACxB,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;EAClB,8BAA8B;EAC9B,sBAAsB;EACtB,8BAA8B;EAC9B,qBAAqB;EACrB,gCAAgC;EAChC,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;EAClB,6BAA6B;EAC7B,wBAAwB;EACxB,kCAAkC;EAClC,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;EACtB,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA,2EAA2E;;AAE3E;EACE,wBAAwB;EACxB,sBAAsB;EACtB,4BAA4B;EAC5B,2BAA2B;EAC3B,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;EAC9B,qBAAqB;EACrB,iCAAiC;EACjC,sBAAsB;EACtB,iCAAiC;EACjC,wBAAwB;EACxB,mCAAmC;EACnC,mBAAmB;EACnB,+BAA+B;EAC/B,qBAAqB;EACrB,gCAAgC;EAChC,wBAAwB;EACxB,mCAAmC;EACnC,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;EACtB,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;AACxB","sourcesContent":["/* Theme Presets\n * Complete token sets applied via .theme-* class on <body>.\n * Default theme (\"Tonal: OHIF Blue\") = no class (uses :root values from tailwind.css).\n * Outside @layer base so presets override :root via proximity on <body>.\n *\n * Tonal themes: full hue-shifted palettes (surfaces, borders, text all carry the theme hue).\n * Neutral themes: desaturated/achromatic surfaces with a colored primary accent.\n */\n\n/* ─── Tonal: Orchid ──────────────────────────────────────────────────── */\n\n.theme-orchid {\n  --highlight: 292 75% 62%;\n  --neutral: 270 18% 55%;\n  --neutral-light: 275 35% 75%;\n  --neutral-dark: 268 20% 24%;\n  --background: 270 45% 6%;\n  --foreground: 280 15% 96%;\n  --card: 268 40% 10%;\n  --card-foreground: 280 15% 96%;\n  --popover: 264 48% 13%;\n  --popover-foreground: 280 15% 96%;\n  --primary: 270 85% 65%;\n  --primary-foreground: 0 0% 98%;\n  --secondary: 268 45% 32%;\n  --secondary-foreground: 275 45% 88%;\n  --muted: 268 40% 10%;\n  --muted-foreground: 272 30% 60%;\n  --accent: 268 50% 20%;\n  --accent-foreground: 280 15% 96%;\n  --destructive: 0 65% 40%;\n  --destructive-foreground: 0 0% 98%;\n  --border: 268 30% 18%;\n  --input: 268 40% 25%;\n  --ring: 270 80% 60%;\n  --chart-1: 270 70% 58%;\n  --chart-2: 160 55% 45%;\n  --chart-3: 35 80% 55%;\n  --chart-4: 200 65% 55%;\n  --chart-5: 340 70% 55%;\n}\n\n/* ─── Tonal: Arctic ──────────────────────────────────────────────────── */\n\n.theme-arctic {\n  --highlight: 173 81% 52%;\n  --neutral: 185 20% 55%;\n  --neutral-light: 180 40% 78%;\n  --neutral-dark: 190 18% 22%;\n  --background: 0 0% 0%;\n  --foreground: 180 10% 97%;\n  --card: 203 39% 9%;\n  --card-foreground: 180 10% 97%;\n  --popover: 202 54% 11%;\n  --popover-foreground: 180 10% 97%;\n  --primary: 175 85% 42%;\n  --primary-foreground: 185 50% 8%;\n  --secondary: 180 45% 28%;\n  --secondary-foreground: 175 50% 88%;\n  --muted: 203 39% 9%;\n  --muted-foreground: 185 30% 60%;\n  --accent: 185 55% 18%;\n  --accent-foreground: 180 10% 97%;\n  --destructive: 0 65% 35%;\n  --destructive-foreground: 0 0% 98%;\n  --border: 190 25% 17%;\n  --input: 223 40% 24%;\n  --ring: 175 85% 42%;\n  --chart-1: 175 75% 45%;\n  --chart-2: 140 60% 42%;\n  --chart-3: 35 80% 55%;\n  --chart-4: 280 65% 58%;\n  --chart-5: 330 75% 55%;\n}\n\n/* ─── Tonal: Verdant ─────────────────────────────────────────────────── */\n\n.theme-verdant {\n  --highlight: 152 79% 52%;\n  --neutral: 150 15% 52%;\n  --neutral-light: 145 30% 72%;\n  --neutral-dark: 155 18% 24%;\n  --background: 155 40% 5%;\n  --foreground: 140 15% 95%;\n  --card: 152 35% 9%;\n  --card-foreground: 140 15% 95%;\n  --popover: 167 65% 10%;\n  --popover-foreground: 140 15% 95%;\n  --primary: 152 75% 40%;\n  --primary-foreground: 155 50% 8%;\n  --secondary: 150 40% 26%;\n  --secondary-foreground: 145 40% 85%;\n  --muted: 152 35% 9%;\n  --muted-foreground: 148 25% 55%;\n  --accent: 150 45% 16%;\n  --accent-foreground: 140 15% 95%;\n  --destructive: 0 65% 38%;\n  --destructive-foreground: 0 0% 98%;\n  --border: 150 25% 16%;\n  --input: 150 35% 22%;\n  --ring: 152 75% 40%;\n  --chart-1: 152 70% 42%;\n  --chart-2: 200 60% 48%;\n  --chart-3: 35 80% 55%;\n  --chart-4: 280 60% 55%;\n  --chart-5: 340 70% 52%;\n}\n\n/* ─── Neutral: Midnight ──────────────────────────────────────────────── */\n\n.theme-midnight {\n  --highlight: 188 90% 58%;\n  --neutral: 213 22% 59%;\n  --neutral-light: 214 69% 81%;\n  --neutral-dark: 214 16% 21%;\n  --background: 240 15% 3%;\n  --foreground: 0 0% 99%;\n  --card: 240 12% 8%;\n  --card-foreground: 0 0% 99%;\n  --popover: 225 45% 13%;\n  --popover-foreground: 0 0% 99%;\n  --primary: 210 100% 62%;\n  --primary-foreground: 0 0% 99%;\n  --secondary: 215 55% 32%;\n  --secondary-foreground: 200 60% 88%;\n  --muted: 240 12% 8%;\n  --muted-foreground: 210 40% 70%;\n  --accent: 220 65% 20%;\n  --accent-foreground: 0 0% 99%;\n  --destructive: 0 70% 35%;\n  --destructive-foreground: 0 0% 99%;\n  --border: 240 10% 18%;\n  --input: 225 35% 24%;\n  --ring: 210 100% 62%;\n  --chart-1: 210 85% 55%;\n  --chart-2: 165 70% 42%;\n  --chart-3: 35 85% 52%;\n  --chart-4: 275 70% 58%;\n  --chart-5: 335 80% 52%;\n}\n\n/* ─── Neutral: Slate ─────────────────────────────────────────────────── */\n\n.theme-slate {\n  --highlight: 217 97% 52%;\n  --neutral: 0 0% 55%;\n  --neutral-light: 0 0% 75%;\n  --neutral-dark: 0 0% 25%;\n  --background: 0 0% 0%;\n  --foreground: 0 0% 96%;\n  --card: 0 0% 7%;\n  --card-foreground: 0 0% 96%;\n  --popover: 0 0% 9%;\n  --popover-foreground: 0 0% 96%;\n  --primary: 230 75% 55%;\n  --primary-foreground: 0 0% 98%;\n  --secondary: 0 0% 25%;\n  --secondary-foreground: 0 0% 85%;\n  --muted: 0 0% 7%;\n  --muted-foreground: 0 0% 60%;\n  --accent: 0 0% 18%;\n  --accent-foreground: 0 0% 96%;\n  --destructive: 0 65% 40%;\n  --destructive-foreground: 0 0% 98%;\n  --border: 0 0% 18%;\n  --input: 0 0% 22%;\n  --ring: 215 75% 55%;\n  --chart-1: 215 70% 55%;\n  --chart-2: 160 55% 45%;\n  --chart-3: 35 75% 55%;\n  --chart-4: 280 60% 58%;\n  --chart-5: 340 70% 55%;\n}\n\n/* ─── Neutral: Deep ──────────────────────────────────────────────────── */\n\n.theme-deep {\n  --highlight: 184 53% 54%;\n  --neutral: 215 15% 50%;\n  --neutral-light: 210 20% 68%;\n  --neutral-dark: 220 18% 22%;\n  --background: 0 0% 0%;\n  --foreground: 215 15% 82%;\n  --card: 218 25% 5%;\n  --card-foreground: 215 15% 82%;\n  --popover: 215 30% 8%;\n  --popover-foreground: 215 15% 82%;\n  --primary: 200 43% 48%;\n  --primary-foreground: 210 20% 92%;\n  --secondary: 218 30% 18%;\n  --secondary-foreground: 215 25% 75%;\n  --muted: 214 28% 5%;\n  --muted-foreground: 215 18% 48%;\n  --accent: 216 32% 12%;\n  --accent-foreground: 215 15% 82%;\n  --destructive: 0 50% 35%;\n  --destructive-foreground: 0 15% 90%;\n  --border: 218 22% 10%;\n  --input: 216 28% 15%;\n  --ring: 215 45% 42%;\n  --chart-1: 215 50% 45%;\n  --chart-2: 175 40% 38%;\n  --chart-3: 35 50% 45%;\n  --chart-4: 280 40% 48%;\n  --chart-5: 340 45% 45%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
